// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuFilterPill{--saltButton-textTransform:none;max-width:var(--vuuFilterPill-maxWidth,200px)}.vuuFilterPill-tooltip ul{padding-left:var(--salt-spacing-400)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
